import React, { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import '../../../../assets/stylesheets/ProfileSlide/ProfilePopUp.scss';
import { requestSetAvatar } from "../../../../store/actionCreators/avatar";
import { getAvatarMenu, getGlobalAccountAvatar } from "../../../../store/selectors";

const Avatar = ({ }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const avatarMenu = useSelector(getAvatarMenu);
    const profileAvatar = useSelector(getGlobalAccountAvatar);
    const [selectedAvatar, setSelectedAvatar] = useState({});

    const setProfileAvatar = () => {
        dispatch(requestSetAvatar(selectedAvatar));
    };

    return (
        <React.Fragment>
            <div className={`profileDialog profile-profile-avatar`}>
                <div className="dialogContent scrollable">
                    {
                        avatarMenu.map((avatarSet, sprIndex) => <React.Fragment key={sprIndex}>
                            {
                                avatarSet.frames.map((av, avIndex) =>
                                    <div
                                        key={avIndex}
                                        onClick={() => setSelectedAvatar({
                                            name: av.filename,
                                            imagePath: avatarSet.jsonUrl
                                        })}
                                        style={{
                                            backgroundImage: `url(${avatarSet.imageUrl})`,
                                            backgroundPosition: `-${av.frame.x}px -${av.frame.y}px`,
                                            height: `${av.frame.h}px`,
                                            width: `${av.frame.w}px`
                                        }}
                                        className={`avatarChoice ${(av.filename === selectedAvatar.name && avatarSet.jsonUrl === selectedAvatar.imagePath) ? 'selected' : ''}`}
                                    >
                                    </div>)
                            }
                        </React.Fragment>

                        )
                    }
                </div>
                <div className="dialogConfirmBox">
                    <button className={'primary'} onClick={() => setProfileAvatar()} disabled={Object.keys(selectedAvatar).length === 0}>
                        {t('button.confirm')}
                    </button>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Avatar;

